import { render, staticRenderFns } from "./TokenDetail.pc.vue?vue&type=template&id=5b4d57dd&scoped=true&"
import script from "./TokenDetail.pc.vue?vue&type=script&lang=js&"
export * from "./TokenDetail.pc.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetail.pc.vue?vue&type=style&index=0&id=5b4d57dd&lang=scss&scoped=true&"
import style1 from "./TokenDetail.pc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d57dd",
  null
  
)

export default component.exports